import { DataTableV2, Intro } from "components/commons";
import { locale } from "localization/en";
import KeyAccountFilter from "./key-account-filter";
import { useMount, useRouter } from "hooks";
import { Path, FormMode } from "enums";
import { useContext } from "react";
import { StationContext } from "contexts";
import { keyAccountLogsColumn } from "./key-account-list-column";
import { mapDataToList, mapFilterToRequest } from "./key-account-list-mapper";
import { getKeyAccountCollectionListApi } from "apis";
import { initialFilterState } from "./key-account-filter.state";
import useDataTable from "hooks/useDataTable";

const KeyAccountModule = () => {
  const { station } = useContext(StationContext);

  useMount(() => {
    console.log(station.stationCode);
  });

  const { filter, search, table } = useDataTable({
    api: {
      api: getKeyAccountCollectionListApi,
      params: {
        page: 1,
        perPage: 10,
        stationCode: station.stationCode,
      },
      mapper: (param) => {
        return param;
      },
    },
    filter: {
      initialState: initialFilterState(),
      mapper: mapFilterToRequest,
      disregardFilterCount: {
        dateBy: true,
      },
    },
    table: {
      key: "keyAccountCollections",
      mapper: (keyAccountCollections) =>
        mapDataToList({
          keyAccountCollections,
          onClickView: (keyAccountCollectionId) => {
            router.push(Path.ViewKeyAccountDetails(keyAccountCollectionId, FormMode.View));
          },
        }),
      columns: keyAccountLogsColumn,
    },
  });

  const router = useRouter();
  return (
    <div>
      <Intro title={locale.keyAccountCollection} />
      <KeyAccountFilter {...filter} {...search} />
      <DataTableV2 {...table} />
    </div>
  );
};

export default KeyAccountModule;
